import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import Common_en            from './locales/en/Common.json';
import Live_view_en         from './locales/en/LiveView.json';
import Recognition_en       from './locales/en/Recognition.json';

import Common_ja            from './locales/ja/Common.json';
import Live_view_ja         from './locales/ja/LiveView.json';
import Recognition_ja       from './locales/ja/Recognition.json';

//setup
import Setup_Floorplan_en   from './locales/en/0SetupFloorplan.json';
import Place_Cameras_en     from './locales/en/1PlaceCameras.json';
import Setup_Cameras_en     from './locales/en/2SetupCameras.json';
import Define_Map_Area_en   from './locales/en/3DefineMapArea.json';
import Define_Image_Area_en from './locales/en/4DefineImageArea.json';
import Check_Transform_en   from './locales/en/5CheckTransform.json';
import Crop_Image_en        from './locales/en/6CropImage.json';
import Setup_Confirm_en     from './locales/en/7SetupConfirm.json';
import Review_Setup_en      from './locales/en/8ReviewSetup.json';

import Setup_Floorplan_ja   from './locales/ja/0SetupFloorplan.json';
import Place_Cameras_ja     from './locales/ja/1PlaceCameras.json';
import Setup_Cameras_ja     from './locales/ja/2SetupCameras.json';
import Define_Map_Area_ja   from './locales/ja/3DefineMapArea.json';
import Define_Image_Area_ja from './locales/ja/4DefineImageArea.json';
import Check_Transform_ja   from './locales/ja/5CheckTransform.json';
import Crop_Image_ja        from './locales/ja/6CropImage.json';
import Setup_Confirm_ja     from './locales/ja/7SetupConfirm.json';
import Review_Setup_ja      from './locales/ja/8ReviewSetup.json';

const resources = {
  en: {
    Common: Common_en,
    SetupFloorplan: Setup_Floorplan_en,
    PlaceCameras: Place_Cameras_en,
    SetupCameras: Setup_Cameras_en,
    DefineMapArea: Define_Map_Area_en,
    DefineImageArea: Define_Image_Area_en,
    CheckTransform: Check_Transform_en,
    CropImage: Crop_Image_en,
    SetupConfirm: Setup_Confirm_en,
    ReviewSetup: Review_Setup_en,
    
    LiveView: Live_view_en,
    Recognition: Recognition_en
  },
  ja: {
    Common: Common_ja,
    SetupFloorplan: Setup_Floorplan_ja,
    PlaceCameras: Place_Cameras_ja,
    SetupCameras: Setup_Cameras_ja,
    DefineMapArea: Define_Map_Area_ja,
    DefineImageArea: Define_Image_Area_ja,
    CheckTransform: Check_Transform_ja,
    CropImage: Crop_Image_ja,
    SetupConfirm: Setup_Confirm_ja,
    ReviewSetup: Review_Setup_ja,

    LiveView: Live_view_ja,
    Recognition: Recognition_ja
  },
};

i18n.use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'ja',
    lng: localStorage.getItem('language') || navigator.language,
    interpolation: {
      escapeValue: false,
    },
    defaultNS: 'Common',
    ns: ['Common','SetupFloorplan','PlaceCameras','SetupCameras','DefineMapArea',
      'DefineImageArea','CheckTransform','CropImage','SetupConfirm','ReviewSetup',
      'LiveView','Recognition' ],
  });

export default i18n;